<template>
  <div
    class="progress-bar"
    :class="`progress-bar-${type}`"
  >
    <div
      class="bar"
      :style="{ width: `${percentage}%` }"
    />
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    percentage: {
      type: Number,
      default: 0,
    },

    type: {
      type: String,
      default: 'default',
    },
  },
})
</script>

<style lang="scss">
$border-radius: 10px;

/*! purgecss start ignore */
.progress-bar {
  overflow: hidden;
  display: block;
  position: relative;
  width: 100%;

  &-default {
    border-radius: $border-radius;
    height: 24px;
    background: theme('colors.lightest-blue-transparent');
    box-shadow: inset 0 0 5px theme('colors.gray.DEFAULT');

    .bar {
      background-color: theme('colors.orange.DEFAULT');
    }
  }

  &-modern {
    border-radius: $border-radius;
    height: 20px;
    background: white;

    .bar {
      border-radius: $border-radius;
      background-color: theme('colors.blue.DEFAULT');
    }
  }

  .bar {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
}
/*! purgecss end ignore */
</style>
